module.exports = __webpack_public_path__ + "static/media/grade-graph.867887b7.png";